import { z } from "zod"

const MAX_DURATION_MS = 24 * 60 * 60 * 1000

// `start`/`end` are local datetime-local values; empty `end` = ongoing. The
// transform converts them to ISO instants (null for an open end).
export const sessionFormSchema = z
  .object({
    type: z.enum(["night", "day_rest", "nap"]),
    start: z.string().min(1, "Ange en starttid"),
    end: z.string(),
  })
  .superRefine((val, ctx) => {
    const now = Date.now()
    const start = new Date(val.start).getTime()

    if (Number.isNaN(start)) {
      ctx.addIssue({ code: "custom", path: ["start"], message: "Ogiltig starttid" })
      return
    }
    if (start > now) {
      ctx.addIssue({
        code: "custom",
        path: ["start"],
        message: "Starttiden kan inte vara i framtiden",
      })
    }

    if (val.end === "") return

    const end = new Date(val.end).getTime()
    if (Number.isNaN(end)) {
      ctx.addIssue({ code: "custom", path: ["end"], message: "Ogiltig sluttid" })
      return
    }
    if (end > now) {
      ctx.addIssue({
        code: "custom",
        path: ["end"],
        message: "Sluttiden kan inte vara i framtiden",
      })
    }
    if (end <= start) {
      ctx.addIssue({
        code: "custom",
        path: ["end"],
        message: "Sluttiden måste vara efter starttiden",
      })
    }
    if (end - start > MAX_DURATION_MS) {
      ctx.addIssue({
        code: "custom",
        path: ["end"],
        message: "Sömnpasset kan inte vara längre än 24 timmar",
      })
    }
  })
  .transform((val) => ({
    type: val.type,
    startTime: new Date(val.start).toISOString(),
    endTime: val.end === "" ? null : new Date(val.end).toISOString(),
  }))

export type SessionFormInput = z.input<typeof sessionFormSchema>
export type SessionFormValues = z.output<typeof sessionFormSchema>
